import className from 'classnames/bind';
import { FC } from 'react';

import { FooterMatrix } from '@/helpers/NavHelper';
import { ChunkedNav } from '@/types/Navigation';

import styles from './mobileNavigation.module.scss';
import { MobileNavigationFooter } from './MobileNavigationFooter';
import { MobileNavigationItem } from './MobileNavigationItem';

const cx = className.bind(styles);

interface Props {
  navigationItems: ChunkedNav;
  footerItems: FooterMatrix[];
  isMobileMenuActive: boolean;
}

const MobileNavigation: FC<Props> = (props) => {
  const { navigationItems, footerItems, isMobileMenuActive } = props;

  const mobileNavigationContainerClassName = cx({
    [styles.mobileNavigationContainer]: true,
    [styles.mobileNavigationContainerActive]: isMobileMenuActive,
  });

  return (
    <div className={mobileNavigationContainerClassName}>
      <div className={styles.mobileNavigationContent}>
        <ul>
          {navigationItems?.map(([navItem, subNavItems], index) => (
            <MobileNavigationItem
              key={`${navItem.id}-${index}`}
              text={navItem.text}
              url={navItem.link}
              subMenuItemChunks={subNavItems}
            />
          ))}
        </ul>
        <div className={styles.mobileNavigationDivider} />
        <MobileNavigationFooter navigationItems={footerItems} />
      </div>
    </div>
  );
};

export default MobileNavigation;
